import "leaflet.markercluster"
import { createPathComponent } from "@react-leaflet/core"
import L from "leaflet"

interface MarkerClusterGroupProps {
  disableClusteringAtZoom?: number
}

const MarkerClusterGroup = createPathComponent(
  ({ children: _c, disableClusteringAtZoom, ...props }: MarkerClusterGroupProps & any, ctx) => {
    const clusterProps: Record<string, any> = {}
    const clusterEvents: Record<string, any> = {}

    // Splitting props and events to different objects
    Object.entries(props).forEach(([propName, prop]) =>
      propName.startsWith("on") ? (clusterEvents[propName] = prop) : (clusterProps[propName] = prop),
    )

    // Add disableClusteringAtZoom to cluster props if provided
    if (typeof disableClusteringAtZoom === "number") {
      clusterProps.disableClusteringAtZoom = disableClusteringAtZoom
    }

    // Custom icon creation function to handle server-side clusters
    if (!clusterProps.iconCreateFunction) {
      clusterProps.iconCreateFunction = (cluster: L.MarkerCluster) => {
        const markers = cluster.getAllChildMarkers()

        // Calculate total point count by checking if any child is a server-side cluster
        let count = 0
        markers.forEach((marker) => {
          const options = marker.options as any
          // If marker represents a server-side cluster, add its point count
          // Otherwise, count it as one point
          if (
            options.feature &&
            options.feature.properties &&
            options.feature.properties.isCluster &&
            typeof options.feature.properties.PointCount === "number"
          ) {
            count += options.feature.properties.PointCount
          } else {
            count += 1
          }
        })

        // Create appropriate class based on count
        let className = "marker-cluster marker-cluster-"
        if (count < 10) {
          className += "small"
        } else if (count < 100) {
          className += "medium"
        } else {
          className += "large"
        }

        return L.divIcon({
          html: `<div><span>${count}</span></div>`,
          className: className,
          iconSize: new L.Point(40, 40),
        })
      }
    }

    // Creating markerClusterGroup Leaflet element
    const markerClusterGroup = L.markerClusterGroup(clusterProps)

    // Initializing event listeners
    Object.entries(clusterEvents).forEach(([eventAsProp, callback]) => {
      const clusterEvent = `cluster${eventAsProp.substring(2).toLowerCase()}`
      markerClusterGroup.on(clusterEvent, callback)
    })

    return {
      instance: markerClusterGroup,
      context: { ...ctx, layerContainer: markerClusterGroup },
    }
  },
)

export default MarkerClusterGroup
